import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { Store, select } from '@ngrx/store';
import { getVerbatimsLoaded, LoadVerbatims, ReportsState } from '../store';
import { tap, map, take } from 'rxjs/operators';
import { Observable } from 'rxjs';

@Injectable({
    providedIn: 'root'
})
export class VerbatimsGuard  {

    constructor(private store: Store<ReportsState>) { }

    canActivate(next: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> {
        const cacheKey: string = next.parent.params.cacheKey;
        return this.checkstore(cacheKey);
    }
    
    checkstore(cacheKey: string): Observable<boolean> {
        // Do stuff
        return this.store.pipe(
            select(getVerbatimsLoaded),
            tap(loading => {
                if(!loading)
                    this.store.dispatch(new LoadVerbatims(cacheKey))
            }),
            take(1),
            map(() => true)
        );
    }

}
